export default defineNuxtPlugin(() => {
  // Grab the full location hash immediately (before the router runs)
  const rawHash = typeof window !== 'undefined' ? window.location.hash : ''

  // Get the query string (everything after the ?)
  const rawQuery = typeof window !== 'undefined' ? window.location.search : ''

  // Look for tgWebAppData=... (case-insensitive just in case)
  const match = /(?:^|[#&])tgwebappdata=([^&]+)/i.exec(rawHash)

  const decodedRawHash = decodeURI(rawHash)

  if (match) {
    // Store the FULL "#...". Keeping the leading # makes appending trivial.
    sessionStorage.setItem('tma:hash', decodedRawHash)
    sessionStorage.setItem('tma:queryParams', rawQuery)
    // For convenience, also persist the decoded raw initData string
  } else if (rawHash) {
    // If there is some hash but not tgWebAppData, still keep it (just in case)
    sessionStorage.setItem('tma:hash', decodedRawHash)
    sessionStorage.setItem('tma:queryParams', rawQuery)
  }
})
